import { useLayoutEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import debounce from '../../../utils/debounce';

function getDimensionObject(node, dimensions) {
  const rect = node?.getBoundingClientRect();

  if (!rect) {
    return {};
  }

  const newDimensions = {
    width: rect.width,
    height: rect.height,
    top: 'x' in rect ? rect.x : rect.top,
    left: 'y' in rect ? rect.y : rect.left,
    x: 'x' in rect ? rect.x : rect.left,
    y: 'y' in rect ? rect.y : rect.top,
    right: rect.right,
    bottom: rect.bottom,
  };

  if (!dimensions || !shallowEqual(newDimensions, dimensions)) {
    return newDimensions;
  }

  return dimensions;
}

function useDimensions(ref, liveMeasure = true) {
  const [dimensions, setDimensions] = useState({});

  const measure = () => {
    if (ref?.current) {
      setDimensions((prevDimensions) => {
        const newDimensions = getDimensionObject(ref.current);
        return shallowEqual(newDimensions, prevDimensions)
          ? prevDimensions
          : newDimensions;
      });
    }
  };

  useLayoutEffect(() => {
    measure();
    const debouncedMeasure = debounce(measure, 100);
    if (liveMeasure) {
      window.addEventListener('resize', debouncedMeasure);
      window.addEventListener('scroll', debouncedMeasure);
    }
    return () => {
      if (liveMeasure) {
        window.removeEventListener('resize', debouncedMeasure);
        window.removeEventListener('scroll', debouncedMeasure);
      }
    };
  }, [ref?.current]);

  return [dimensions, measure];
}

export default useDimensions;
